export default {
	actualities: 'Actualités',
	backHome: 'Retourner aux actualités',
	buttons: {
		editAlert: 'Afficher ou modifier l\'alerte',
		editBirthday: 'Ajouter ou modifier un anniversaire',
		eventParticipate: 'Participer',
		newActuality: 'Publier une actualité',
		newEvent: 'Créer un évènement',
		newNotice: 'Créer une annonce'
	},
	consult: 'Consulter',
	consultEventsBtn: 'Consulter tous les évènements',
	consultNoticesBtn: 'Voir toutes les annonces',
	credits: 'Ordre des dentistes du Québec. Tous droits réservés.',
	categories: 'Documents et ressources',
	errors: {
		server: {
			init: 'La connexion au serveur n\'a pas pu être établie.',
		},
	},
	events: 'Évènements',
	eventSeparator: 'Évènements passés',
	homeWelcome: 'Bienvenue sur',
	leaveEmpty: 'Laisser vide',
	less: '... moins',
	login: {
		title: 'Bienvenue sur Dentaclic, l\'intranet de l\'Ordre des dentistes du Québec',
		description: 'Consultez les nouvelles et actualités de l\'Ordre, explorez les évènements à venir et accédez facilement à des ressources, des documents et autres outils.',
		instruction: 'Connectez-vous directement avec votre adresse courriel ODQ. Pas d\'inscription requise.',
		codeInstruction: 'Entrez le code à 6 chiffres envoyé à',
		emailPlaceholder: 'Exemple : prénom.nom',
		newCodeSent: 'Un nouveau code a été envoyé à votre adresse courriel.',
		noCodeLink: 'renvoyez le code',
		noCodeMessage: 'Vous ne trouvez pas votre code? Consultez votre dossier de courriers indésirables ou',
		submit: 'Soumettre'
	},
	more: '... plus',
	nextEvents: 'Prochains évènements',
	newNotices: 'Dernières annonces du babillard',
	noCategory: 'Aucune sous-catégorie n\'a été ajoutée à cette catégorie pour l\'instant.',
	noDoc: 'Aucun document n\'a été ajouté à cette catégorie pour l\'instant.',
	noFilteredEvents: 'Malheureusement, aucun évènement ne correspond à vos critères de recherche.',
	noFilteredNotices: 'Malheureusement, aucune annonce ne correspond à vos critères de recherche.',
	notFound: 'Page non trouvée',
	notices: 'Babillard',
	noticesFilterNew: 'Nouveautés depuis ma dernière visite',
	noticesFilterMine: 'Afficher mes annonces seulement',
	noticesFiltersTitle: 'Filtres',
	noticesSinceVisit: 'nouvelles annonces depuis votre dernière visite',
	notification: {
		beenDeleted: 'a été supprimée par un administrateur parce que',
		yourNotice: 'Votre annonce',
	},
	popup: {
		copiedText: 'Le lien de partage a été copié à votre presse-papier.',
		createdElement: 'a été créé avec succès.',
		deletedElement: 'a été supprimé avec succès.',
		modifiedElement: 'a été modifié avec succès.',
		theAlert: 'L\'alerte',
		theEmployee: 'L\'employé',
		theRapidLinks: 'La section actions et liens rapides',
	},
	rapidLinksTitle: 'Actions et liens rapides',
	weekDays: {
		sunday: 'D',
		monday: 'L',
		tuesday: 'M',
		wednesday: 'M',
		thursday: 'J',
		friday: 'V',
		saturday: 'S',
	}
}
